import service from 'service';

export const getTransactions = ({ queryKey: [, params] }) => {
  const url = '/core_wallet/v1/wallet_ledger';
  return service.get(url, { params });
};

export const getTransactionGraph = ({ queryKey: [, params] }) => {
  const url = '/core_wallet/v1/wallet_ledger/graph';
  return service.get(url, { params });
};

export const getTopSubscribers = ({ queryKey: [, params] }) => {
  const url = '/core_wallet/v1/wallet_ledger/top_subscriber';
  return service.get(url, { params });
};

export default {};
